import React from 'react'
import PropTypes from 'prop-types'
import Tooltip from '../../../../atoms/Tooltip'

function getPrimaryContact (contacts) {
  if (!contacts?.length) return null
  return contacts.find(c => c.hoh) || contacts[0]
}

function getContactFullName (contact) {
  return contact?.full_name ||
    `${contact?.first_name ?? ''} ${contact?.last_name ?? ''}`.trim() ||
    null
}

const pillStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '11px',
  fontWeight: 600,
  lineHeight: 1,
  padding: '2px 6px',
  borderRadius: '10px',
  backgroundColor: 'var(--color-neutral-200)',
  color: 'var(--color-neutral-700)',
  marginLeft: '6px',
  cursor: 'default',
  verticalAlign: 'middle'
}

const unassignedStyle = {
  fontStyle: 'italic',
  color: 'var(--text-color-subtle)'
}

/**
 * Compact display for a row: primary contact name + "+N" pill with tooltip.
 * Shows "Unassigned" when no linked contacts.
 */
export function LinkedContactRow ({ contacts, style }) {
  const primary = getPrimaryContact(contacts)
  const primaryName = getContactFullName(primary)

  if (!primaryName) {
    return <span style={{ ...unassignedStyle, ...style }}>Unassigned</span>
  }

  const rest = contacts.filter(c => c !== primary)
  const restNames = rest.map(c => getContactFullName(c) || 'Unknown').join('\n')

  return (
    <span style={style}>
      {primaryName}
      {rest.length > 0 && (
        <Tooltip title={<span style={{ whiteSpace: 'pre-line' }}>{restNames}</span>}>
          <span style={pillStyle}>+{rest.length}</span>
        </Tooltip>
      )}
    </span>
  )
}

LinkedContactRow.propTypes = {
  contacts: PropTypes.array,
  style: PropTypes.object
}

/**
 * Full display for a detail view: lists all linked contacts, or "Unassigned".
 */
export function LinkedContactDetail ({ contacts, labelStyle, valueStyle }) {
  if (!contacts?.length) {
    return (
      <>
        <div style={labelStyle}>Contact</div>
        <div style={{ ...valueStyle, ...unassignedStyle }}>Unassigned</div>
      </>
    )
  }

  const label = contacts.length === 1 ? 'Contact' : 'Contacts'

  return (
    <>
      <div style={labelStyle}>{label}</div>
      <div style={valueStyle}>
        {contacts.map((c, i) => {
          const name = getContactFullName(c) || 'Unknown'
          return (
            <div key={c.id ?? c.contact_id ?? i}>
              {name}
              {c.hoh ? <span style={{ marginLeft: '6px', fontSize: '11px', color: 'var(--text-color-subtle)' }}>(HOH)</span> : null}
            </div>
          )
        })}
      </div>
    </>
  )
}

LinkedContactDetail.propTypes = {
  contacts: PropTypes.array,
  labelStyle: PropTypes.object,
  valueStyle: PropTypes.object
}
